import React from 'react';
import { Nav, NavItem} from 'react-bootstrap';
import {LinkContainer,IndexLinkContainer} from 'react-router-bootstrap';
import FontAwesome from 'react-fontawesome';
import img from '~/assets/Logo_big.png';
//import img from '../../../assets/Logo_big.png';

class SideNavbar extends React.Component {
  handleSelect=selectedVal=>{
   // const navItem = getNavItem(selectedVal);
    //this.props.setSelectedTab(navItem);
  }

  render(){
    return (
      <div>       
        <div className="navbar navbar-fixed-left">
        <div className="kinetik-logo">
        <div className="background-logo">
              <img src={img} alt="Kinetik Logo"/>
              </div>
          </div>
  
         <Nav onSelect={this.handleSelect}>
            <IndexLinkContainer to="/billing/home"><NavItem eventKey={1}><FontAwesome className="icon" name='home' /><span className="sidemenu-text"> Home</span></NavItem></IndexLinkContainer>
            <LinkContainer to="/billing/submitclaims"><NavItem eventKey={2} ><FontAwesome className="icon" name='fas fa-tasks' /><span className="sidemenu-text"> Submit Claims</span></NavItem></LinkContainer>
            <LinkContainer to="/billing/claimstatus"><NavItem eventKey={3}><FontAwesome className="icon" name='check' /><span className="sidemenu-text">Batch Status</span></NavItem></LinkContainer> 
            {/* <LinkContainer to="/billing/followup"><NavItem eventKey={5} ><FontAwesome className="icon" name='phone' /> <span className="sidemenu-text"> Follow Up</span></NavItem></LinkContainer> */}
            <LinkContainer to="/billing/era"><NavItem eventKey={6} ><FontAwesome className="icon" name='file-text-o' /> <span className="sidemenu-text"> ERA</span></NavItem></LinkContainer>
            {/* <LinkContainer to="/billing/reports"><NavItem eventKey={6} ><FontAwesome className="icon" name='print' /> <span className="sidemenu-text"> Reports</span></NavItem></LinkContainer> */}
            <LinkContainer to="/ediConverter"><NavItem eventKey={4} ><FontAwesome className="icon" name='file-text-o' /> <span className="sidemenu-text"> EDI Converter</span></NavItem></LinkContainer>

            <LinkContainer to="/settings"><NavItem eventKey={7} ><FontAwesome className="icon" name='fas fa-cog' /> <span className="sidemenu-text"> Settings</span></NavItem></LinkContainer>
            <LinkContainer to="/logout"><NavItem eventKey={8} ><FontAwesome className="icon" name='fas fa-sign-out' /> <span className="sidemenu-text"> Logout</span></NavItem></LinkContainer>

          </Nav>
          
  
       </div>
      
     </div>
    )
  }
}

export default SideNavbar;

// function getNavItem(num){
//   switch (num) {
//     case 1:
//       return "Manage Trips"
//       case 2:
//       return "Claims"
//       case 3:
//       return "A/R"
//       case 4:
//       return "Database"
//       case 5:
//       return "Settings"
//       case 6:
//       return "Logout"
//     default:
//       return "Manage Trips"
//   }
// }



// WEBPACK FOOTER //
// ./src/app/common/side_navbar/SideNavbar.js